export default __webpack_public_path__ + "static/media/c.ca323b32.png";